import { registerTranslateConfig, Key, ITranslateConfig, lookup } from "@appnest/lit-translate";
import axios from 'axios';

let url:string = '';

registerTranslateConfig({
    loader: (lang) => {
        if ((<any>window).paramasterI18nBundle && (<any>window).paramasterI18nBundle[lang]) {
            return new Promise(resolve => {
                resolve((<any>window).paramasterI18nBundle[lang]);
            })
        }
        return axios.get(url.replace(/\{\{lang\}\}/, lang)).then((response) => response.data)
    },

    lookup: (key: Key, config: ITranslateConfig):any => {
        if (config.strings?.hasOwnProperty(`${key}`)) {
            return String(config.strings[key]);
        }

        return lookup(key, config);
    },
});

export const initI18n = async (bundleUrl:string/*, allowHtmlContent:boolean = false*/) => {
    url = bundleUrl;
}

export const getFlagForLang = (lang:string) => {
    return process.env.I18N_FLAG_LANG_URL?.replace(/\{\{lang\}\}/, lang);
}

export const getFlagForCountry = (country:string) => {
    return process.env.I18N_FLAG_COUNTRY_URL?.replace(/\{\{lang\}\}/, country);
}
